
import { MealCard } from "@/components/seller/MealCard";

interface MealsGridProps {
  meals: any[];
  onDeleteMeal: (id: string) => void;
  onEditMeal: (meal: any) => void;
  onToggleMealStatus: (id: string, status: string) => void;
}

const MealsGrid = ({ meals, onDeleteMeal, onEditMeal, onToggleMealStatus }: MealsGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {meals.map((meal) => (
        <MealCard
          key={meal.id}
          meal={{
            ...meal,
            id: meal.id,
            cuisine: meal.cuisine_type || '',
            dietary: meal.dietary_tags || [],
            preOrder: meal.is_pre_order,
            scheduledDate: meal.scheduled_date,
            availablePortions: meal.available_portions,
            preparationTime: meal.preparation_time,
            status: meal.status
          }}
          onDelete={() => onDeleteMeal(meal.id)}
          onEdit={() => onEditMeal(meal)}
          onToggleStatus={() => onToggleMealStatus(meal.id, meal.status)}
        />
      ))}
    </div>
  );
};

export default MealsGrid;
